export const SKOOL_SIGNUP_URL = 'https://www.skool.com/reboot-rebels-ai-builders-8764/about';
